// ViewGerenciarConfigSistema/hook/useConfigSistema.ts
import { useEffect, useState } from "react";
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
import { useError } from "../../../uteis/mensagens/useError";
import { message } from "antd";

interface IConfigSistema {
  id: number;
  chave: string;
  valor: string;
  descricao?: string;
}

export const useConfigSistema = () => {
  const [configs, setConfigs] = useState<IConfigSistema[]>([]);
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState<number | null>(null);

  const { showError, contextHolder } = useError();

    const Token = validateToken();

  useEffect(() => {
    carregarConfigs();
  }, []);

  const carregarConfigs = async () => {

    if(!Token)return null;

    try {
      const resp = await axios.get(
        `${Globais.DOMINIOBACK}/config-sistema`,{
              headers: { Authorization: Token.AuthStr },
            }
      );
      

      setConfigs(resp.data);
    } catch (err: any) {
      showError("Erro ao carregar configurações");
    } finally {
      setLoading(false);
    }
  };

  const salvarConfig = async (id: number, valor: string, descricao: string) => {

    if(!Token)return null;

    setSavingId(id);

    
    

    try {
      await axios.patch(
      `${Globais.DOMINIOBACK}/config-sistema/${id}`,
      { valor, descricao },
      {
        headers: { Authorization: Token.AuthStr },
      }
);


     

      message.success("Configuração salva com sucesso!");
      carregarConfigs(); // recarregar lista atualizada
    } catch (err: any) {
      showError("Erro ao salvar configuração");
    } finally {
      setSavingId(null);
    }
  };

  return {
    configs,
    loading,
    savingId,
    salvarConfig,
    contextHolder,
  };
};
